export enum ValueFormat {
    MapCoordinatesDMS = 1,
    MapCoordinatesDD = 2,
    TextAsMask = 3,
    TextAsCutout = 4
}

export enum ElementType {
    Text = 1,
    Map = 2,
    Image = 3
}

export const SourceValueFormatOptions = [
    { label: 'Coordinates (DMS) - 48° 51\' 30.24" N, 2° 17\' 40.2" E', value: ValueFormat.MapCoordinatesDMS },
    { label: 'Coordinates (DD) - 48.858400, 2.294500', value: ValueFormat.MapCoordinatesDD }
];

export const MAP_VALUE_FORMATS: ValueFormat[] = [ValueFormat.MapCoordinatesDMS, ValueFormat.MapCoordinatesDD];
